<template>
    <div id="sig-container" class="block full form-horizontal" pagination>
        <table-component :data="casas" v-if="casas.length > 0" @click-event="clickEvent">
            <table-column slot="label" :label="'ID'" v-bind:value="'id'"></table-column>
            <table-column slot="label" :label="'Nombre'" v-bind:value="'nombre'"></table-column>
            <table-column slot="label" :label="'Acciones'" :icon="'fa'">
                <template slot="icon" :icon="'fa fa-edit'" :class="'btn btn-sm btn-primary'" :slug="'editar-casa'" :tooltip="'Editar Casa de Cobranza'"></template>
            </table-column>
        </table-component>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
    name: 'CasasCobranza',
    data: () => {
        return {
            
        }
    },
    computed: {
        ...mapGetters({'casas': 'casascobranza/casas'})
    },
    components: {
        TableComponent: () => import('@@/components/table/TableComponent'),
        TableColumn: () => import('@@/components/table/TableColumn')
    },
    methods: {
        clickEvent(data, slug) {
            switch(slug) {
                case 'editar-casa':
                    this.$router.push({name: 'editar-casa-cobranza', params: { id: data.id }})
                    break
            }
        },
    },
    mounted() {
        this.$store.dispatch('casascobranza/fetch', {endpoint: 'administracion/casascobranza', params: {paginar: false}})
    }
}
</script>